














import { Component, Mixins } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import moment from 'moment'
import LiquorLicense from '@/components/LiquorLicense.vue'

@Component({
  components: {
    LiquorLicense
  }
})
export default class LiquorLicensePage extends Mixins(IconsMixin, AuthMixin) {}
